// =====================================================
// Bundle Item Click Handler
// Uses event delegation so it works for dynamically
// loaded content (like quick view)
// =====================================================
document.addEventListener("click", function (e) {

  // Find the closest bundle item from the clicked element
  const bundleItem = e.target.closest(".bundle-item");

  // Run only if a bundle item is clicked and it is not sold out
  if (bundleItem && !bundleItem.classList.contains("sold-out")) {

    // -------------------------------------------------
    // Toggle the "active" class on the clicked bundle
    // This marks the bundle as selected / unselected
    // -------------------------------------------------
    bundleItem.classList.toggle("active");


    // -------------------------------------------------
    // Hide .shiprocket-headless inside this bundle item
    // (Used to prevent showing the shipping estimator)
    // -------------------------------------------------
    const shiprocketElement = bundleItem.querySelector(".shiprocket-headless");
    if (shiprocketElement) {
      shiprocketElement.style.display = "none";
    }


    // -------------------------------------------------
    // Find the product section related to this bundle
    // If not found, fallback to document
    // -------------------------------------------------
    const productSection = bundleItem.closest(".product-section") || document;

    // Main product shipping estimator
    const productForm = productSection.querySelector(".shiprocket-headless");

    // Add to Cart button
    const addToCartButton = productSection.querySelector(".add-to-cart");


    // -------------------------------------------------
    // Adjust Add to Cart button width
    // If any bundle is selected -> make button full width
    // -------------------------------------------------
    if (addToCartButton) {
      const anyActive = productSection.querySelectorAll(".bundle-item.active").length > 0;
      addToCartButton.classList.toggle("full-width-btn", anyActive);
    }


    // -------------------------------------------------
    // Show or hide the main product shipping estimator
    // Hide if any bundle is active
    // -------------------------------------------------
    if (productForm) {
      const anyActive = productSection.querySelectorAll(".bundle-item.active").length > 0;
      productForm.style.display = anyActive ? "none" : "";
    }
  }
});